import React from 'react';
import OverlayComponent from './OverLay';
import howItWorksData from './howItWorks.data';
import { howItWorksStyle as styles } from './howItWorks.tailwind';

const HowItWorks = () => {
  return (
    <section className={styles.container} id="how-it-works">
      {/* Heading */}
      <h1 className="landing_page_sub_heading">HOW IT WORKS</h1>

      {/* All Cards */}
      <div className={styles.card_wrpr}>
        {/* cards data */}
        {howItWorksData?.map((data, key) => (
          <OverlayComponent key={key} data={data} />
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
